// Where a value shown in a Production Packet is actually changed. The packet
// never keeps its own copy of these; it sends the coordinator to the owner.
//   Proposal App: Load-In / Strike dates and times, Hard Set / Hard Out,
//     venue and address, the client's day-of contact (they flow
//     Proposal App → EPS → Production Packet; an EPS-only edit is undone the
//     next time the proposal is published).
//   EPS: the Departure date and the EPS's own operational fields, and the
//     project's Drive folder.

export const PROPOSAL_APP_URL = 'https://app.maykerevents.com/';

/** The project's proposal in the Proposal App, or '' without a usable Project ID. */
export function proposalAppUrl(projectId) {
  const pid = String(projectId || '').trim();
  return /^\d+$/.test(pid) ? `${PROPOSAL_APP_URL}?projectNumber=${encodeURIComponent(pid)}` : '';
}

// Review items fixed in the Proposal App (venue, address, day-of contact) or on the EPS.
const PROPOSAL_OWNED_ISSUES = ['venue_missing', 'venue_tbd', 'address_missing', 'address_incomplete', 'contact_missing'];
const EPS_OWNED_ISSUES = ['member_folder_missing'];

/** Where a review item is fixed: { href, label } ('' href when there is no single place). */
export function issueLink(issue, epsUrl) {
  const code = issue && issue.code;
  if (PROPOSAL_OWNED_ISSUES.indexOf(code) !== -1) {
    const pid = issue.projectId || (issue.where && issue.where.projectId);
    return { href: proposalAppUrl(pid), label: 'Edit in Proposal App' };
  }
  if (EPS_OWNED_ISSUES.indexOf(code) !== -1) return { href: epsUrl || '', label: 'Edit in EPS' };
  return { href: '', label: '' };
}

/** Who owns an EPS-derived Run of Show row: the Departure date is the EPS's; Load-In and Strike the Proposal App's. */
export function rosRowOwner(row) {
  const key = String((row && (row.key || row.id)) || '');
  const keys = (row && row.keys) || [key];
  return keys.every((k) => /:departure$/.test(String(k))) ? 'eps' : 'proposal';
}
